/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Address, HexString, Val, Struct } from "@alephium/web3";
import { default as allStructsJson } from "../structs.ral.json";
export const AllStructs = allStructsJson.map((json) => Struct.fromJson(json));
export interface UserRewardSharingInfo extends Record<string, Val> {
  amount: bigint;
  rewardPerToken: bigint;
}
export interface UserStakingInfo extends Record<string, Val> {
  amount: bigint;
  connectedDapps: HexString;
}
export interface VoteInfo extends Record<string, Val> {
  proposalVoted: bigint;
  amount: bigint;
}
